import { Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/user/userSlice";
import { retrieveStudent, studentSlice, selectStudent } from "../../../redux/student/studentSlice";
import { useAppDispatch } from "../../../app/hooks";
import { LoadState } from "../../../redux/common";
import { isTokenReady } from "../../../features/user/UserAvatar";
import { useEffect } from "react";

interface StudentPageTitleProps {
    studentId?: string;
}

const StudentPageTitle = ({ studentId }: StudentPageTitleProps) => {
    const user = useSelector(selectUser);
    const student = useSelector(selectStudent);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (student.selected && student.selected.id != studentId) {
            dispatch(studentSlice.actions.clean());
        }
        if (student.state.state == LoadState.NotStarted && isTokenReady(user)) {
            dispatch(retrieveStudent({ studentId: studentId }));
        }
    }, [studentId, student, user]);

    const name = student.selected?.nickname ? student.selected?.nickname : student.selected?.name;

    return name ?
        <Typography variant="h6" component="div" overflow="hidden" whiteSpace="nowrap" sx={{ flexGrow: 1 }}>
            {name}
        </Typography>
        : <Typography variant="h6" component="div" overflow="hidden" whiteSpace="nowrap" sx={{ flexGrow: 1 }}>
            Aluno
        </Typography>;
};

export default StudentPageTitle;